import React from 'react';
import vrExperience from '../../assets/images/home/vr_experience.jpg';

const DiscoverSection = () => {
    return (
        <section className="relative py-32 overflow-hidden">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0">
                <img
                    src={vrExperience}
                    alt="VR Learning Experience"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
            </div>

            {/* Content */}
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
                    Discover How <span className="text-primary">NexGen Learning</span> Transforms Education
                </h2>
                <button className="inline-flex items-center px-8 py-4 bg-primary text-white text-lg font-semibold rounded-full hover:bg-primary/90 transform hover:-translate-y-0.5 transition-all duration-200 shadow-lg hover:shadow-xl">
                    Start your free trial
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </button>
            </div>
        </section>
    );
};

export default DiscoverSection; 